
import {HRMEN} from "./hrm/en";
import {WorkPlaceEN} from "./workplace/en";
import {SettingEN} from "./setting/en";
import {evaluationKpiEN} from "./hrm/evaluation/en";

export const LayoutEN = {
    "layout":{

            "profile":"Profile",
            "system":"System",
            "statementInfo":"Statement Info",
            "userManual":"User manual",
            "theme":"Theme",
            "changePassword":"Change Password",
            "changeEmail":"Change Email",
            "language":"Language",
            "vi":"Tiếng Việt",
            "en":"English",
            "setting":"Setting",
            "logout":"Logout",
            "timekeeping" : "Timekeeping",
            "contract": "Contract",
            "addWorkNormal": "Work normal",
            "applicationSetting" : "Application",
            "applicationAction" : "Create Application",
            ...HRMEN,
            ...WorkPlaceEN,
            ...SettingEN,
            ...evaluationKpiEN

    }
}